// mui
import { Icon } from '@/components/atoms/Icon';
import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

interface DismissShortlistItemFormProps {
  providerName: string;
  regulatoryID: string;
  detail: string | null;
  setDetail: (val: string | null) => void;
  reason: string | null;
  setReason: (val: string | null) => void;
}

const REASONS = [
  'No availability',
  'Too expensive',
  'Too far away',
  'Family declined',
  'Other',
];

export const DismissShortlistItemForm = ({
  providerName,
  regulatoryID,
  detail,
  setDetail,
  reason,
  setReason,
}: DismissShortlistItemFormProps) => {
  return (
    <Stack direction='column' spacing={2}>
      <Typography>
        {providerName} ({regulatoryID}) will be hidden from the shortlist and
        moved to bottom of the list. You can restore it at any time.
      </Typography>
      <FormControl fullWidth size='small'>
        <Select
          notched
          value={reason ?? ''}
          onChange={(e) => {
            const newReason = e.target.value;

            if (newReason !== 'Other') {
              setDetail(null);
            }
            setReason(newReason || null);
          }}
          label={REASONS.find((r) => r === reason) || ''}
        >
          {REASONS.map((reason) => (
            <MenuItem key={reason} value={reason}>
              {reason}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label='Detail (optional)'
        value={detail}
        disabled={reason !== 'Other'}
        onChange={(e) => setDetail(e.target.value)}
        size='small'
        fullWidth
      />
    </Stack>
  );
};

DismissShortlistItemForm.displayName = 'DismissShortlistItemForm';
export default DismissShortlistItemForm;
